import PropTypes from 'prop-types';

const action = PropTypes.shape({
  id: PropTypes.number.isRequired,
  action: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
});

export default action;
